import React, { FunctionComponent, useContext } from 'react';
import { VerifiedIcon } from './VerifiedIcon';

import { useTranslation } from 'react-i18next';
import { ColorsContext } from '../../context/ColorsContext';
import styles from './VerifiedCharity.scss';
import { useOptimizely } from '../../hooks/useOptimizely';
import { Experiments } from '../../constants/experiments';

const VerifiedCharity: FunctionComponent = () => {
  const textColor = useContext(ColorsContext)?.foregroundColor;
  const { t } = useTranslation('common', { useSuspense: false });
  const optimizely = useOptimizely();

  function onSelectVerify() {
    if (optimizely) {
      optimizely.track(Experiments.TrackingEvents.verifiedCharity);
    }
  }

  return (
    <div>
      <a
        href="#verifiedBanner"
        className={`${styles.verifiedCharity} jg-about-charity__link jg-space-mtsm jg-space-mbsm`}
        style={{ color: textColor }}
        onClick={onSelectVerify}
      >
        <VerifiedIcon /> {t('page.verifiedCharity')}
      </a>
    </div>
  );
};

export default VerifiedCharity;
